export default __webpack_public_path__ + "static/small-image-sportplus-1-0c59ced3a71cf9a4cb37921e62f37ffa.png";